import React from 'react';

import "./GoogleMap.scss";

export const GoogleMap = (props) => {
    

    return (
        <div className="GoogleMap">
            {!props.loc ? null: <iframe
                src={"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2560.755170776882!2d14.480522499999994!3d50.072146599999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470b9372b4565c11%3A0xac4f2ed081c64a0f!2s" + encodeURI(props.loc) + "!5e0!3m2!1scs!2scz!4v1585735917235!5m2!1scs!2scz"}
                allowFullScreen=""
                aria-hidden="true"
                tabIndex="0">
            </iframe>}
        </div>
    );
}
